import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { documentFreeTagsState } from "store/document/documentCommon";
import { TempDocumentDetailResponseWithAny } from "../queries/useTempDocumentDetailQuery";

const useFreeTags = ({
  tempDocumentDetail,
}: {
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}) => {
  // 자유 태그
  const [freeTags, setFreeTags] = useRecoilState(documentFreeTagsState);

  function getFreeTagUuids() {
    return freeTags.map((tag) => tag.uuid);
  }

  useEffect(() => {
    if (!tempDocumentDetail) return;

    setFreeTags(tempDocumentDetail.freeTags);
  }, [tempDocumentDetail]);
  return {
    freeTags,
    getFreeTagUuids,
  };
};

export default useFreeTags;
